'use strict';



(function () {


  angular.module('specsguardApp', [
    'sgConstants',
    'ngCookies',
    'ngResource',
    'ngSanitize',
    'ui.router',
    'angularInlineEdit',
    'ngMaterial',
    'ngMessages',
    'angularMoment',
    'dndLists',
    'mdSteppers',
    'angularFileUpload',
    'ui.tinymce',
  ]);
  var initInjector = angular.injector(['ng']);
  var $http = initInjector.get('$http');

  $http.get('/api/app/labels').then(
    function (response) {

      angular.module('sgConstants', []).constant('LABELS_CONSTANT', response['data']['data']);

      // Create the event
      var event = new CustomEvent("specsguardready");

      // Dispatch/Trigger/Fire the event
      document.dispatchEvent(event);
    }
  )

})();
